const apiUrl = process.env.REACT_APP_API_URL;
export const GetJutgeProblemesIdRanking = async (problemaId: string, id_activitat: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${id_activitat}/problemes/${problemaId}/ranking`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
